

import React, { useEffect, useState } from 'react';
import { Card, Button, Form } from 'react-bootstrap';
import { FaMicrophone, FaPaperPlane, FaUpload } from "react-icons/fa";
import OrderReports from './OrderReports';
import ProductionReports from './ProductionReports';
import QualityNcReports from './QualityNcReports';
import ResourceReports from './ResourceReports'
import SupervisorDashboard from '../SupervisorDashboard/SupervisorDashboard';
import Management from '../management/Management';
import { TrendingUp } from 'react-feather';
import { TrendingDown } from 'lucide-react';
import config from "../../config/config";
import MonthlyProductionSummaryModal from './MonthlyProductionSummaryModal';
import SetMachineUtilization from '../modal/setMachineUtilization';
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from 'react-toastify';
const SeniorManagement = () => {
    const [activeTab, setActiveTab] = useState('Production Reports');
    const [seniorDashboard, setSeniorDashboard] = useState([])
    const [metrics, setMetrics] = useState([]);
    const [monthlyProduction, setMonthlyProduction] = useState(false)
    const [machineUtilization, setMachineUtilization] = useState(false)
    const fetchSeniorDashboard = async () => {
        const token = getAuthToken();
        if (!token) return;
        try {
            const response = await axios.get(`${config.API}/senmanager/dashboard`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            const result = response?.data;
            if (result?.success) {
                setSeniorDashboard(result)
                console.log("Senior Dashboard Data:", result.data);
            } else {
                console.warn("API call failed:", result?.message || "Something went wrong");
            }
        } catch (err) {
            console.error("Error fetching fetchSeniorDashboard:", err.message);
        }
    };

    useEffect(() => {
        fetchSeniorDashboard()
    }, [])

const renderContent = () => {
    switch (activeTab) {
        case 'Production Reports':
            return <ProductionReports />;

        case 'Quality & Nc Reports':
            return <QualityNcReports />;

        case 'Resource Reports':
            return <ResourceReports />;

        case 'Order Reports':
            return <OrderReports />;

        case 'Manager Dashboard':
            return <Management />;

        case 'Supervisor Dashboard':
            return <SupervisorDashboard />;

        default:
            return <ProductionReports />;
    }
};

    const production = Number(seniorDashboard?.monthly_production) || 0;
    const target = Number(seniorDashboard?.production_target) || 0;
    const monthlyProductions = target > 0 ? ((production / target) * 100).toFixed(2) : 0;
    useEffect(() => {
        if (seniorDashboard) {
            setMetrics([
                {
                    title: "Monthly Production",
                    value: "Click to View",
                    subtitle: 'Monthly Production Target',
                    icon: (
                        <div
                            style={{
                                backgroundColor: "#e0ebff",
                                borderRadius: "50%",
                                padding: "10px",
                                width: "fit-content",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <TrendingUp color="#1D4ED8" size={18} />
                        </div>
                    ),
                },
                {
                    title: "Quality Metrics",
                    value: `${(Number(seniorDashboard?.quality_metrics) || 0).toFixed(2)}%`,
                    subtitle: "First Pass Yield",
                    icon: (
                        <div
                            style={{
                                backgroundColor: "#b0f0d8ff",
                                borderRadius: "50%",
                                padding: "10px",
                                width: "fit-content",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <TrendingUp color="#0c7549ff" size={18} />
                        </div>
                    ),
                },
                {
                    title: "Machine Utilization",
                    value: `${(Number(seniorDashboard?.machine_utilization) || 0).toFixed(2)}%`,
                    subtitle: "Avg. Utilization",
                    icon: (
                        <div
                            style={{
                                backgroundColor: "#fff4c2",
                                borderRadius: "50%",
                                padding: "10px",
                                width: "fit-content",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <TrendingDown color="#8B2500" size={18} />
                        </div>
                    ),
                },
                {
                    title: "Total Present Resources",
                    value: `${(Number(seniorDashboard?.resource_efficiency) || 0).toFixed(2)}%`,
                    subtitle: "Total Present Resources",
                    icon: (
                        <div
                            style={{
                                backgroundColor: "#e0ebff",
                                borderRadius: "50%",
                                padding: "10px",
                                width: "fit-content",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <TrendingUp color="#1D4ED8" size={18} />
                        </div>
                    ),
                },
            ]);
        }
    }, [seniorDashboard]);
    return (
        <div className="container-fluid p-4" style={{ background: "#EEF2F8" }}>
            <div className="row font_family">
                <div className="col-lg-1">
                </div>
                <div className="col-lg-10">
                    <div className="row">
                        <div className="row align-items-center mb-4">
                            <div className="col-12 col-md-6">
                                <strong className='fs-4'>Senior Management Dashboard</strong>
                            </div>
                            <div className="col-12 col-md-6 text-md-end mt-3 mt-md-0">
                                <Form.Control type="month" defaultValue="2025-06" className="d-inline w-auto me-2" />
                                <Button variant="outline-primary">Export</Button>
                            </div>
                        </div>
                        <div className="row">
                            {metrics.map((metric, idx) => (
                                <div className="col-12 col-sm-6 col-md-3 mb-3" key={idx} style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        if (metric.title === "Monthly Production") {
                                            setMonthlyProduction(true);
                                        }
                                        if (metric.title === "Quality Metrics") {
                                            // setQualityMetrics(true);
                                        }
                                        if (metric.title === "Machine Utilization") {
                                            setMachineUtilization(true);
                                            // toast.success("Machine Utilization clicked");
                                        }
                                        if (metric.title === "Total Present Resources") {
                                            // setTotalPresentResources(true);
                                        }
                                    }}
                                >
                                    <Card border={metric.color} className='w-100 h-100'>
                                        <Card.Body>
                                            <Card.Title>{metric.title}</Card.Title>
                                            <h4 className="fw-bold d-flex justify-content-between align-items-center">
                                                {metric.value}
                                                <span>{metric.icon}</span>
                                            </h4>
                                            <small>{metric.subtitle}</small>
                                        </Card.Body>
                                    </Card>
                                </div>
                            ))}
                        </div>
                        <div
                            className="d-flex flex-wrap rounded text-dark px-2 py-1 font_family mt-4 m-1"
                            style={{ background: "#e0e9fbff" }}
                        >
                            <div className="flex-fill">
                                <TabItem
                                    label="Production Reports"
                                    active={activeTab === "Production Reports"}
                                    onClick={() => setActiveTab("Production Reports")}
                                />
                            </div>

                            <div className="flex-fill">
                                <TabItem
                                    label="Quality & Nc Reports"
                                    active={activeTab === "Quality & Nc Reports"}
                                    onClick={() => setActiveTab("Quality & Nc Reports")}
                                />
                            </div>

                            <div className="flex-fill">
                                <TabItem
                                    label="Resource Reports"
                                    active={activeTab === "Resource Reports"}
                                    onClick={() => setActiveTab("Resource Reports")}
                                />
                            </div>

                            <div className="flex-fill">
                                <TabItem
                                    label="Order Reports"
                                    active={activeTab === "Order Reports"}
                                    onClick={() => setActiveTab("Order Reports")}
                                />
                            </div>

                            <div className="flex-fill">
                                <TabItem
                                    label="Manager Dashboard"
                                    active={activeTab === "Manager Dashboard"}
                                    onClick={() => setActiveTab("Manager Dashboard")}
                                />
                            </div>

                            <div className="flex-fill">
                                <TabItem
                                    label="Supervisor Dashboard"
                                    active={activeTab === "Supervisor Dashboard"}
                                    onClick={() => setActiveTab("Supervisor Dashboard")}
                                />
                            </div>
                        </div>
                        <div className="">
                            {renderContent()}
                        </div>
                    </div>
                    <div className="row mt-4 m-1">
                        <div className="col-12">
                            <Card>
                                <Card.Body>
                                    <div className="bg-light p-3 mb-3 rounded" style={{ width: "fit-content", maxWidth: "100%" }}>
                                        Hi how can I help you today?
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-3" />
                                        <div className="col-lg-6">
                                            <div className="d-flex flex-wrap gap-2 mb-3 justify-content-center justify-content-md-start">
                                                {Array(4).fill("Chat Prompts").map((text, i) => (
                                                    <div key={i} className="border px-3 py-1 rounded bg-light log_button">
                                                        {text}
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="border rounded p-2">
                                                <div className="d-flex align-items-center flex-wrap gap-2">
                                                    <div className="d-flex gap-2 flex-wrap">
                                                        <Button variant="light" className="border">
                                                            <FaUpload />
                                                        </Button>
                                                        <Button variant="light" className="border">
                                                            <FaMicrophone />
                                                        </Button>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <textarea
                                                            className="form-control border-0 shadow-none w-100"
                                                            rows="1"
                                                            placeholder="Type here..."
                                                            style={{ resize: "none", minHeight: "38px" }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <Button variant="primary">
                                                            <FaPaperPlane />
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3" />
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                        {/* MonthlyProductionBoardModal */}
                        <MonthlyProductionSummaryModal
                            show={monthlyProduction}
                            handleClose={() => setMonthlyProduction(false)}
                        />
                        <SetMachineUtilization
                            show={machineUtilization}
                            handleClose={() => setMachineUtilization(false)}
                        />
                    </div>
                </div>
                <div className="col-lg-1" />
            </div>
        </div>
    );
};

function TabItem({ label, icon, active, onClick }) {
    return (
        <div
            className={`flex-fill text-center py-2 rounded d-flex align-items-center justify-content-center gap-2 ${active ? 'bg-light text-dark fw-bold' : ''}`}
            style={{ cursor: 'pointer' }}
            onClick={onClick}
        >
            {icon}
            <span>{label}</span>
        </div>
    );
}

export default SeniorManagement;
